import styled from 'styled-components';
import StarList from '../../StarList';

export const TitleContainer = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
	flex-wrap: wrap;

	${props => props.theme.breakpoints.up('xs')} {
		flex-direction: column;
	}

	${props => props.theme.breakpoints.up('md')} {
		flex-direction: row;
	}
`;

export const StyledStarList = styled(StarList)`
	${props => props.theme.breakpoints.up('xs')} {
		padding-top: 15px;
	}
	${props => props.theme.breakpoints.up('md')} {
		padding-left: 15px;
	}
`;
